import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";

type Props = {
    open?: any;
    isCloseModal?: any;
    item?: any
}

const InfoModal: React.FC<Props> = ({ open, isCloseModal, item }: Props) => {
    const [infoItem, setInfoItem] = useState<any>(item);

    useEffect(() => {
        setInfoItem(item)
    }, [item]);

    const handleInput = (event: any): void => {
        setInfoItem({ title: infoItem.title, items: event.target.value });
    };

    const closeDepModal = (isOpen: boolean) => {
        isCloseModal()
    }

    return (
        <Modal
            title={`${infoItem.title}`}
            open={open}
            onCancel={() => closeDepModal(false)}
            footer={[
                <Button key="cancel" onClick={() => closeDepModal(false)}>
                    Отмена
                </Button>,
                <Button
                    key="link"
                    type="primary"
                    onClick={() => closeDepModal(false)}
                >
                    Сохранить
                </Button>,
            ]
            }
        >
            <p>Введите значения через запятую</p>

            <TextArea
                placeholder="Введите значения через запятую"
                value={infoItem.items}
                name="description"
                rows={4}
                onChange={handleInput}
            />

        </Modal>
    )
};

export default InfoModal;
